import mapper from 'object-mapper';
import { add, sub, div, calculate } from '@/Libs/Decimal';

export default (data, shop_id) => {
  const sheet1 = Object.keys(data)[0];
  const r = mapper(data[sheet1], {
    '[].订单号': [{ 'key': '[].ordersn' }],
    '[].下单时间': [{ 'key': '[].created' }, { 'key': '[].orders_info[0].booking_date' }],
    '[].预订日期': [{ 'key': '[].orders_info[0].departure_date' }], // 未验证的这个是截止使用时间
    '[].订单金额': [
      { 'key': '[].total_fee' },
      // { 'key': '[].transaction_amount' },
    ],
    '[].实付金额': [
      { 'key': '[].orders_info[0].payment' },
      { 'key': '[].orders_info[0].transaction_amount' },
      { 'key': '[].transaction_amount' },
    ],
    // '[].优惠金额': [
    //   { 'key': '[].orders_info[0].payment' },
    // ],
    '[].订单备注项': [{ 'key': '[].web_remark' }],
    '[].联系人': {
      'key': '[].name',
    },
    '[].联系人电话': {
      'key': '[].phone',
    },
    '[].联系人email': {
      'key': '[].email',
    },
    '[].订单状态': [{ 'key': '[].orders_info[0].status_text', 'default': '' }, { 'key': '[].status_text' }],
    '[].产品名称': {
      'key': '[].orders_info[0].product_name',
    },
    // '[].最后验证时间': {
    //   'key': '[].orders_info[0].departure_date1',
    // },
    '[].票数': {
      'key': '[].orders_info[0].num',
      'default': 1,
    },
    '[].退款张数': {
      'key': '[].orders_info[0].refund_num',
      'default': 0,
    },
  })
    .map((row) => ({
      ...row,
      orders_info: row.orders_info.map((oi) => {
        const oiRefundfee = calculate(`${oi.transaction_amount}/${oi.num}*${oi.refund_num}`);
        return {
          ...oi,
          order_types: 2,
          refund_fee: oiRefundfee,
          transaction_amount: sub(oi.payment, oiRefundfee),
          // departure_date: oi.departure_date1 || oi.departure_date2,
        };
      }),
      is_online: 0,
      pf_id: 4,
      shop_id: shop_id,
      order_types: 2,
    }))
    .filter((row) => row.status_text !== '已关闭');
  return r;
};
